import { render, staticRenderFns } from "./SchemeServiceDrawer.vue?vue&type=template&id=64548775&scoped=true"
import script from "./SchemeServiceDrawer.vue?vue&type=script&lang=js"
export * from "./SchemeServiceDrawer.vue?vue&type=script&lang=js"
import style0 from "./SchemeServiceDrawer.vue?vue&type=style&index=0&id=64548775&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64548775",
  null
  
)

export default component.exports